import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import {
  EmailTemplate, EmailTemplateKey, RenderedEmail, SaveEmailTemplateRequest,
} from '../interfaces/sales/emailTemplate.interface';

/** F7: e-mail templates. Preview renders sample data only; no endpoint here sends mail. */
export const EmailTemplateService = {
  list: async (i: string): Promise<EmailTemplate[]> =>
    (await axios.get(ENDPOINTS.EMAIL_TEMPLATES.LIST(i))).data,

  get: async (i: string, key: EmailTemplateKey): Promise<EmailTemplate> =>
    (await axios.get(ENDPOINTS.EMAIL_TEMPLATES.ONE(i, key))).data,

  save: async (i: string, key: EmailTemplateKey, dto: SaveEmailTemplateRequest): Promise<EmailTemplate> =>
    (await axios.put(ENDPOINTS.EMAIL_TEMPLATES.ONE(i, key), dto)).data,

  /** Back to the built-in text (soft-deletes the institution's row). */
  reset: async (i: string, key: EmailTemplateKey): Promise<EmailTemplate> =>
    (await axios.delete(ENDPOINTS.EMAIL_TEMPLATES.ONE(i, key))).data,

  /** Draft subject/body, or both omitted for the saved / built-in text. */
  preview: async (i: string, key: EmailTemplateKey, dto: Partial<SaveEmailTemplateRequest> = {}): Promise<RenderedEmail> =>
    (await axios.post(ENDPOINTS.EMAIL_TEMPLATES.PREVIEW(i, key), dto)).data,
};
